import type { Testimonial } from '../testimonials'

/**
 * Melih Sarıkaya's words — the second tab of the quote card that closes the
 * Zorlu Holding story, supplied with it on 2026-09-21 along with his portrait.
 *
 * A second file rather than an edit of `zorlu-holding.ts`, because a card holds
 * one speaker and `testimonialsForStory()` gathers every quote naming the story
 * into the tab strip — the shape Penta Teknoloji's and Akkök Holding's two
 * principals already take.
 *
 * `hallOfFame: false`: the wall carries one card per company and Önder
 * Kaplancık's speaks for this engagement there. It is also the honest place for
 * this one, which is about Vestel's roadmap rather than about the group.
 *
 * The `logo` arrived on 2026-09-22 — a 300x300 transparent square, so it takes
 * the `*card.png` name and is safe on the quote card's grey band. Before it we
 * drew no mark here rather than Zorlu Holding's, which would have named the
 * wrong company above a Vestel attribution.
 */
export const added: Testimonial = {
  company: 'Vestel',
  logo: { name: 'Vestel', src: '/logo/vestelcard.png' },
  portrait: { src: '/photo/portrait-melih-sarikaya.png', alt: 'Melih Sarıkaya' },
  quote: [
    'Assessing each factory separately gave us detail that an overall score could not. We can '
    + 'see where each site should focus and order the roadmap around the areas where cost is '
    + 'created.',
  ],
  attribution: 'Melih Sarıkaya, CIO, Vestel',
  story: 'zorlu-holding',
  hallOfFame: false,
}
